import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.nvaTeal,
  tileBgColor: colors.white,
  iconBgColor: colors.nvaTeal
};
export default imageGallery;